/* @ngInject */
const saleMetadata = (
  saleButtons,
  saleFields
) => {
  const self = {}

  self.favoriteSort = ['number',]

  self.buttons = [
    saleButtons.search,
    saleButtons.edit,
    saleButtons.updateAllAxletrees,
    saleButtons.delete,
  ]

  self.fields = saleFields

  return self
}
export default saleMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/metadata.service.js